import { render, staticRenderFns } from "./PrizeCard.vue?vue&type=template&id=38d23860&scoped=true&"
import script from "./PrizeCard.vue?vue&type=script&lang=js&"
export * from "./PrizeCard.vue?vue&type=script&lang=js&"
import style0 from "./PrizeCard.vue?vue&type=style&index=0&id=38d23860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d23860",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardActions,VCardSubtitle,VCardTitle,VDivider,VIcon,VImg})
